import React, { useState, Fragment, useEffect } from 'react';
import { OverlayView, Marker } from '@react-google-maps/api';
import { useSelector, useDispatch } from 'react-redux';

import {
    visibleMarkersMapSelector, markerDetailViewSelector, markerEditDataSelector
} from '../../../features/places/placesSlice';
import { setCenter, setZoom, mapControlSelector } from '../../../features/map/mapSlice';

import { mdiMapMarkerRadius } from '@mdi/js';

const iconToolsColor = "Ivory";

const PlaceMarker = ({ markerId, map }) => {

    const dispatch = useDispatch();
    const markerData = useSelector(state => state.places.markers[`${markerId}`]);
    const visibleMarkersMap = useSelector(visibleMarkersMapSelector);
    const markerDetailView = useSelector(markerDetailViewSelector);
    const markerEditData = useSelector(markerEditDataSelector);
    const mapControl = useSelector(mapControlSelector);
    const opacity = markerEditData.marker_id === markerDetailView ? 0.5 : 1;
    let lat = 23.5251;
    let lng = 77.8081;

    if (markerData) {
        lat = parseFloat(markerData.marker_coords.lat);
        lng = parseFloat(markerData.marker_coords.lng);
    }

    const [showLabel, setshowLabel] = useState(false);

    useEffect(() => {
        if (markerId === markerDetailView) {
            setshowLabel(true);
        }
    }, [markerDetailView, markerId]);

    useEffect(() => {
        if (visibleMarkersMap.length < 6) {
            setshowLabel(true);
        }
    }, [visibleMarkersMap]);

    useEffect(() => {
        if (markerDetailView === markerId && mapControl === 'marker') {
            //console.log("zoom on me", markerData.marker_name);
            dispatch(setZoom(17));
            dispatch(setCenter({ lat, lng }));
        }
    }, [markerDetailView, markerId, lat, lng, dispatch, mapControl, markerData]);



    const onMarkerClick = (e) => {
        setshowLabel(!showLabel);
    }

    const visible = visibleMarkersMap.indexOf(markerId) !== -1;

    /*let icon = `/assets/history/def30/skyscraper.png`;
    if (window.google) {
        if (visibleMarkersMap.length > 100) {
            icon = {
                path: window.google.maps.SymbolPath.CIRCLE,
                fillColor: activeIconToolsColor,
                fillOpacity: 0.9,
                scale: 4,
                strokeColor: "SlateBlue",
                strokeWeight: 1,
            };
        }
    }*/

    if (markerData && visible && window.google) {
        return (
            <Fragment>
                <Marker
                    //icon={icon}
                    icon={{
                        path: mdiMapMarkerRadius,
                        fillColor: markerData.marker_color,
                        fillOpacity: opacity,
                        anchor: new window.google.maps.Point(
                            10, // width
                            18 // height
                        ),
                        strokeWeight: 1,
                        strokeColor: markerData.marker_color,
                        scale: 1,
                    }}
                    position={{ lat: parseFloat(markerData.marker_coords.lat), lng: parseFloat(markerData.marker_coords.lng) }}
                    onClick={onMarkerClick}
                    title={markerData.marker_name}
                />
                <OverlayView
                    position={{ lat: parseFloat(markerData.marker_coords.lat), lng: parseFloat(markerData.marker_coords.lng) }}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                    <span style={{
                        backgroundColor: iconToolsColor,
                        position: 'absolute',
                        left: 10,
                        top: -10,
                    }}>
                        <b>
                            {showLabel ? `${markerData.marker_name}` : ""}
                        </b>
                    </span>

                </OverlayView>
            </Fragment>

        );
    } else {
        return null;
    }

}

export default React.memo(PlaceMarker);

/**
 *
 <Fragment>
                <img
                    src={`/assets/history/def20/mapmarker.png`}
                    alt={markerData.marker_name}

                />
                <Tag
                    color="#191970"
                    //color="lime"
                    style={{
                        position: 'absolute',
                        left: -0,
                        top: 25,
                    }}
                >
                    <span style={{ color: 'white' }}>
                        {markerData.marker_name}
                    </span>
                </Tag>
            </Fragment>
 */